import { LitElement, html, css } from '@hh/global.js'

class LSInputWrapper extends LitElement {
  static properties = {
    animation: {},
    focused: { type: Boolean, reflect: true },
    filled: { type: Boolean, reflect: true },
    label: { type: String },
    height: { type: String },
    theme: { type: String },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.$select = this.querySelector(`select[slot='input']`)
    this.$select && this.preselectSelectValue()

    if (!!this.querySelector(`[slot='input']`).value && !this.$select) {
      this.filled = true
    }

    if (this.$select && this.label !== 'stacked') {
      this.filled = true
    }
  }

  preselectSelectValue() {
    if (this.$select?.dataset?.default) {
      this.$select.value = this.$select?.dataset?.default
    }
  }

  onChange(e) {
    if (this.animation === 'none' || this.label === 'stacked') return
    this.filled = !!e.target.value
  }

  onFocus() {
    if (this.animation === 'none') return
    this.focused = true
  }

  onFocusOut() {
    if (this.animation === 'none') return
    this.focused = false
  }

  removeFocus() {
    this.focused = false
    this.filled = false
  }

  render() {
    return html`      
      <slot name="icon"></slot>

      <slot name="label"></slot>

      <slot
        name="input"
        @change="${this.onChange}"
        @keydown="${this.onChange}"
        @focusin="${this.onFocus}"
        @focusout="${this.onFocusOut}"
      ></slot>
    `
  }

  static styles = css`
    :host {
      position: relative;
    }

    :host([focused]) ::slotted(label),
    :host([filled]) ::slotted(label) {
      font-size: 9px;
      transform: translateY(-13px);
    }

    :host([animation='disappear'][focused]),
    :host([animation='disappear'][filled]) ::slotted(label) {
      visibility: hidden;
      transform: translateY(0);
      font-size: inherit;
    }
  `
}

customElements.define('ls-input-wrapper', LSInputWrapper)
